import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course03 from "../../../course/course-03/course";
import course05 from "../../../course/course-05/course";
import lesson0313 from "../../course-03/lesson-13/lesson";
import lesson0314 from "../../course-03/lesson-14/lesson";
import lesson0504 from "../lesson-04/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "2b3d0320-1229-49bd-b026-48558139ae0d",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0313),
    lesson: lesson0313,
  },
  {
    id: "68542cec-21f1-40c8-8d77-d228e0cce82c",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0314),
    lesson: lesson0314,
  },
  {
    id: "86a8e70c-bf65-46c5-8a4b-df70da79a5d1",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0504),
    lesson: lesson0504,
  },
];

export default lessonLinks;
